var exports = {
  "h": "xa15a2ab7--9b782a--description",
  "o": "xa15a2ab7--9b782a--cian-mortgage-button",
};

module.exports = exports;
